import React, { useState, useEffect } from 'react';
import '../styles/Projects.css';

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/projects')
      .then(res => res.json())
      .then(data => {
        setProjects(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="projects">Loading projects...</div>;
  if (error) return <div className="projects">Error loading projects: {error}</div>;

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2>Featured Projects</h2>
          <span className="section-tag">$ cat featured-projects.json</span>
        <div className="projects-grid">
          {projects.map((project, idx) => (
            <div key={idx} className="project-card">
              <div className="project-header">
                <h3>{project.name}</h3>
                <span className="project-date">{project.date}</span>
              </div>
              <p>{project.description}</p>
              
              {project.highlights && project.highlights.length > 0 && (
                <ul className="highlights">
                  {project.highlights.map((highlight, i) => (
                    <li key={i}>{highlight}</li>
                  ))}
                </ul>
              )}
              
              <div className="tech-stack">
                {project.technologies.map((tech, i) => (
                  <span key={i} className="tech-badge">{tech}</span>
                ))}
              </div>
              <div className="project-links">
                {project.github && <a href={project.github} target="_blank" rel="noreferrer">GitHub</a>}
                {project.demo && <a href={project.demo} target="_blank" rel="noreferrer">Demo</a>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
